<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="1200px"
    :close-on-click-modal="false"
    v-if="dialogVisible"
  >
    <el-steps :active="active" align-center>
      <el-step title="题型选择"></el-step>
      <el-step title="题目制作"></el-step>
    </el-steps>
    <el-form
      v-if="active == 1"
      ref="sourceFormRef"
      :model="sourceForm"
      :rules="sourceRules"
      label-width="120px"
      style="width: 800px; margin: 0 auto;"
    >
      <el-form-item label="题型" prop="questionType">
        <el-select
          style="width: 100%;"
          v-model="sourceForm.questionType"
          placeholder="请选择题型"
          @change="questionTypeChange"
        >
          <el-option
            v-for="item in questionTypesOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="难度等级" prop="courseLevel">
        <el-select
          v-model="sourceForm.courseLevel"
          placeholder="请选择难度等级"
          style="width: 100%;"
        >
          <el-option
            v-for="item in questionLevels"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        :label="sourceForm.questionType < 6 ? '题目资源' : '题干'"
        prop="url"
        v-if="sourceForm.questionType"
      >
        <UploadFile
          v-if="sourceParams.params.type == 'file'"
          v-model="sourceForm.url"
          :limit="1"
          @input="fileChange"
          :maxSize="sourceParams.params.maxSize"
          :fileTypes="sourceParams.params.fileTypes"
        ></UploadFile>
        <div v-else>
          <el-input
            v-model.trim="sourceForm.url"
            :placeholder="
              `请输入${sourceForm.questionType == 6 ? '简答题目' : '时序数据'}`
            "
            type="textarea"
            :autosize="{ minRows: 10, maxRows: 16 }"
            show-word-limit
          ></el-input>
          <a
            v-if="sourceForm.questionType == 5"
            href="/static/时序题目模板.json"
            download
            style="color: #409EFF;"
          >
            <i class="el-icon-download"></i> 时序数据模版下载
          </a>
        </div>
      </el-form-item>
    </el-form>
    <div v-else class="editor-box" v-loading="loading">
      <div class="editor">
        <img v-if="sourceForm.questionType == 1" :src="sourceForm.url" alt="" />
        <template v-if="sourceForm.questionType == 2">
          <ImageLabel
            :fileUrl="sourceForm.url"
            :labelValue="labelValue"
            :labelOptions="labelOptions"
            v-model="answer"
            ref="imageLabelRef"
          ></ImageLabel>
        </template>
        <template v-if="sourceForm.questionType == 7">
          <ImageSplit
            :fileUrl="sourceForm.url"
            :labelValue="labelValue"
            :labelOptions="labelOptions"
            v-model="answer"
            ref="imageSplitRef"
          ></ImageSplit>
        </template>
        <template v-if="sourceForm.questionType == 3">
          <VideoLabel
            :fileUrl="sourceForm.url"
            :labelValue="labelValue"
            :labelOptions="labelOptions"
            v-model="answer"
            ref="videoLabelRef"
          ></VideoLabel>
        </template>
        <template v-if="sourceForm.questionType == 4">
          <AudioLabel
            :fileUrl="sourceForm.url"
            :labelValue="labelValue"
            :labelOptions="labelOptions"
            v-model.trim="answer"
            ref="audioLabelRef"
          ></AudioLabel>
        </template>
        <template v-if="sourceForm.questionType == 5">
          <ChartBrush
            :options="JSON.parse(sourceForm.url)"
            ref="chartsBrushRef"
            v-model.trim="answer"
          ></ChartBrush>
        </template>
        <template v-if="sourceForm.questionType == 6">
          <el-input
            v-model.trim="answer"
            placeholder="请输入简答题答案"
            type="textarea"
            :autosize="{ minRows: 10, maxRows: 16 }"
            show-word-limit
          ></el-input>
        </template>
      </div>
      <div
        class="editor-labels"
        v-if="sourceForm.questionType < 5 || sourceForm.questionType == 7"
      >
        <LabelSelect
          ref="labelSelectRef"
          @change="labelChange"
          @optionsChange="optionsChange"
        ></LabelSelect>
      </div>
    </div>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="nextStep" v-if="active == 1"
        >下一步</el-button
      >
      <el-button @click="active = 1" v-if="active == 2">上一步</el-button>
      <el-button type="primary" @click="submit" v-if="active == 2"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { createInfo, getInfo, editInfo } from "@/api/handsOnBank.js";
import { handsOnQuestionTypes, examLevel } from "@/utils/dict.js";
import { cloneDeep } from "lodash";
import { Message } from "element-ui";
import UploadFile from "@/components/UploadFile";
import VideoLabel from "@/components/VideoLabel.vue";
import AudioLabel from "@/components/AudioLabel.vue";
import ImageLabel from "@/components/ImageLabel.vue";
import ImageSplit from "@/components/ImageSplit.vue";
import ChartBrush from "@/components/ChartBrush.vue";
import LabelSelect from "@/components/LabelSelect.vue";
export default {
  data() {
    const checkJson = (rule, value, callback) => {
      if (this.sourceForm.questionType !== 5) {
        return callback();
      }

      if (!value) {
        return callback(new Error("请输入合法数据"));
      }

      try {
        let obj = value;

        // 如果是字符串，才 parse
        if (typeof value === "string") {
          const cleaned = value.replace(/[\n\r\t]/g, "").trim();

          obj = JSON.parse(cleaned);
        }

        // 最终必须是 object 或 array
        if (typeof obj === "object" && obj !== null) {
          return callback();
        }

        return callback(new Error("请输入合法数据"));
      } catch (e) {
        return callback(new Error("请输入合法数据"));
      }
    };

    return {
      labelOptions: [],
      loading: false,
      fileUrlChanged: false,
      labelValue: null,
      answer: null,
      active: 1,
      dialogTitle: "",
      dialogType: "",
      dialogVisible: false,
      questions: null,
      // 题型选择
      sourceForm: {
        questionType: null,
        url: "",
        courseLevel: null
      },
      sourceRules: {
        questionType: [
          { required: true, message: "请选择题型", trigger: ["blur", "change"] }
        ],
        url: [
          {
            required: true,
            message: "请补充题目资源",
            trigger: ["blur", "change"]
          },
          {
            required: true,
            validator: checkJson,
            trigger: ["blur", "change"]
          }
        ],
        courseLevel: [
          {
            required: true,
            message: "请选择课程级别",
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  components: {
    UploadFile,
    VideoLabel,
    ChartBrush,
    AudioLabel,
    ImageLabel,
    LabelSelect,
    ImageSplit
  },
  computed: {
    sourceParams() {
      return this.sourceForm.questionType
        ? this.questionTypesOptions.find(
            item => item.value == this.sourceForm.questionType
          )
        : {};
    },
    questionTypesOptions() {
      return handsOnQuestionTypes;
    },
    questionLevels() {
      return examLevel;
    }
  },

  methods: {
    optionsChange(val) {
      this.labelOptions = val;
    },
    async nextStep() {
      this.loading = true;
      const valid = await this.$refs.sourceFormRef.validate();
      if (!valid) return;

      this.active++;
      if (this.fileUrlChanged) {
        this.loading = false;
        return;
      }
      requestAnimationFrame(() => {
        try {
          if (this.dialogType == "edit") {
            if (
              this.sourceForm.questionType < 5 ||
              this.sourceForm.questionType == 7
            ) {
              this.$refs.labelSelectRef.setOptions(
                JSON.parse(this.questions.problem)
              );
            }
            let labelData = null;
            setTimeout(async () => {
              const answerData =
                this.sourceForm.questionType == 6
                  ? this.questions.questionAnswer
                  : JSON.parse(this.questions.questionAnswer);
              const problemData =
                this.sourceForm.questionType < 5 ||
                this.sourceForm.questionType == 7
                  ? JSON.parse(this.questions.problem)
                  : this.questions.problem;
              switch (this.sourceForm.questionType) {
                case 1:
                  labelData = problemData.find(
                    item => item.id == answerData[0].cls
                  );
                  await this.$refs.labelSelectRef.changeLabel(labelData);
                  break;
                case 2:
                  answerData.forEach(i => {
                    labelData = problemData.find(item => item.id == i.cls);
                    this.$refs.imageLabelRef.drawMark(
                      {
                        x: i.xmin,
                        y: i.ymin,
                        width: i.xmax - i.xmin,
                        height: i.ymax - i.ymin
                      },
                      labelData
                    );
                  });
                  // await this.$refs.labelSelectRef.changeLabel(labelData);
                  break;
                case 7:
                  answerData.forEach(i => {
                    labelData = problemData.find(item => item.id == i.cls);
                    const points = [];
                    for (let k = 0; k < i.segmentation[0].length; k += 2) {
                      points.push({
                        x: i.segmentation[0][k],
                        y: i.segmentation[0][k + 1]
                      });
                    }
                    this.$refs.imageSplitRef.drawMark(points, labelData);
                  });
                  // const splitData = {
                  //   x: answerData[0].xmin,
                  //   y: answerData[0].ymin,
                  //   width: answerData[0].xmax - answerData[0].xmin,
                  //   height: answerData[0].ymax - answerData[0].ymin
                  // };
                  // labelData = problemData.find(
                  //   item => item.id == answerData[0].cls
                  // );
                  // await this.$refs.labelSelectRef.changeLabel(labelData);
                  // this.$refs.imageSplitRef.drawMark(splitData, labelData);
                  break;
                case 3:
                  labelData = problemData.find(
                    item => item.id == answerData.videoSegments[0].cls
                  );
                  await this.$refs.labelSelectRef.changeLabel(labelData);
                  var answerParams = [];
                  answerData.videoSegments.forEach(item => {
                    const label = problemData.find(i => i.id == item.cls);
                    answerParams.push({
                      start: item.xmin,
                      end: item.xmax,
                      content: label.label,
                      color: label.color
                    });
                  });
                  this.$refs.videoLabelRef.setOptions(answerParams);
                  break;
                case 4:
                  labelData = problemData.find(
                    item => item.id == answerData.voiceSegments[0].cls
                  );
                  await this.$refs.labelSelectRef.changeLabel(labelData);
                  var answerParams = [];
                  answerData.voiceSegments.forEach(item => {
                    const label = problemData.find(i => i.id == item.cls);
                    answerParams.push({
                      start: item.xmin,
                      end: item.xmax,
                      params: label
                    });
                  });

                  this.$refs.audioLabelRef.setOptions(answerParams);
                  break;
                case 5:
                  this.$refs.chartsBrushRef.setOptions(
                    answerData.map(i => ({
                      time: i.x,
                      value: i.y
                    }))
                  );
                  break;
              }
              this.loading = false;
            }, 500);
          } else {
            this.loading = false;
          }
        } catch (e) {
          console.log(e);
        }
      });
    },
    async open(type, id) {
      this.active = 1;
      this.fileUrlChanged = false;
      this.dialogType = type;
      this.dialogTitle = type == "create" ? "新增" : "编辑";
      this.dialogVisible = true;
      this.labelValue = null;
      requestAnimationFrame(() => {
        this.$refs.sourceFormRef.resetFields();
      });
      this.answer = null;
      this.sourceForm = {
        questionType: null,
        url: "",
        courseLevel: ""
      };
      if (type == "edit") {
        const res = await getInfo(id);
        if (res.data.code == 200) {
          this.questions = res.data.data;
          switch (this.questions.questionType) {
            case 1:
              this.sourceForm = {
                questionType: this.questions.questionType,
                url: this.questions.url,
                courseLevel: this.questions.courseLevel
              };
              break;
            case 2:
              this.sourceForm = {
                questionType: this.questions.questionType,
                url: this.questions.url,
                courseLevel: this.questions.courseLevel
              };

              break;
            case 7:
              this.sourceForm = {
                questionType: this.questions.questionType,
                url: this.questions.url,
                courseLevel: this.questions.courseLevel
              };
              break;
            case 3:
              this.sourceForm = {
                questionType: this.questions.questionType,
                url: this.questions.url,
                courseLevel: this.questions.courseLevel
              };
              break;
            case 4:
              this.sourceForm = {
                questionType: this.questions.questionType,
                url: this.questions.url,
                courseLevel: this.questions.courseLevel
              };
              break;
            case 5:
              this.sourceForm = {
                questionType: this.questions.questionType,
                url: this.questions.problem,
                courseLevel: this.questions.courseLevel
              };
              break;
            case 6:
              this.sourceForm = {
                questionType: this.questions.questionType,
                url: this.questions.questionStem,
                courseLevel: this.questions.courseLevel
              };
              this.answer = this.questions.questionAnswer;
              break;
          }
        }
      }
    },
    questionTypeChange() {
      this.sourceForm.url = null;
      this.fileUrlChanged = true;
    },
    fileChange(val) {
      this.fileUrlChanged = true;
      this.sourceForm.url = val;
    },
    labelChange(item) {
      this.labelValue = item;
    },
    async submit() {
      const formData = cloneDeep(this.sourceForm);
      formData.delFlag = 0;
      if (this.sourceParams.params.title) {
        formData.questionStem = this.sourceParams.params.title;
      }
      switch (formData.questionType) {
        case 1:
          if (!this.labelValue) {
            Message.warning("请填写答案");
            return;
          }
          formData.questionAnswer = [{ cls: this.labelValue.id }];
          formData.problem = this.$refs.labelSelectRef.options;
          break;
        case 2:
          if (!this.answer || this.answer.length == 0) {
            Message.warning("请填写答案");
            return;
          }
          formData.problem = this.$refs.labelSelectRef.options;
          // const { width, height, x, y } = this.answer[0].shape;
          formData.questionAnswer = this.answer.map(i => ({
            cls: i.props.id,
            xmin: i.shape.x,
            ymin: i.shape.y,
            xmax: i.shape.x + i.shape.width,
            ymax: i.shape.y + i.shape.height
          }));
          break;
        case 7:
          if (!this.answer || this.answer.length == 0) {
            Message.warning("请填写答案");
            return;
          }
          formData.problem = this.$refs.labelSelectRef.options;
          formData.questionAnswer = this.answer.map(i => ({
            segmentation: [i.shape.flatMap(p => [p.x, p.y])],
            cls: i.props.id
          }));
          break;
        case 3:
          if (!this.answer || this.answer.length == 0) {
            Message.warning("请填写答案");
            return;
          }
          formData.problem = this.$refs.labelSelectRef.options;
          formData.questionAnswer = {
            videoSegments: this.answer.map(i => {
              return {
                cls: i.params.id,
                xmin: Number(i.start.toFixed(1)),
                xmax: Number(i.end.toFixed(1))
              };
            })
          };
          break;
        case 4:
          if (!this.answer || this.answer.length == 0) {
            Message.warning("请填写答案");
            return;
          }
          formData.problem = this.$refs.labelSelectRef.options;
          formData.questionAnswer = {
            voiceSegments: this.answer.map(i => {
              return {
                cls: i.params.id,
                xmin: Number(i.start.toFixed(1)),
                xmax: Number(i.end.toFixed(1))
              };
            })
          };
          break;
        case 5:
          if (!this.answer) {
            Message.warning("请填写答案");
            return;
          }
          formData.problem = JSON.parse(formData.url);
          formData.url = "";
          formData.questionAnswer = this.answer;
          break;
        case 6:
          if (!this.answer) {
            Message.warning("请填写答案");
            return;
          }
          formData.questionStem = formData.url;
          formData.url = "";
          formData.questionAnswer = this.answer;
          break;
      }
      if (formData.questionType != 6)
        formData.questionAnswer = JSON.stringify(formData.questionAnswer);
      if (formData.problem) formData.problem = JSON.stringify(formData.problem);
      if (this.dialogType == "create") {
        await createInfo(formData);
        Message.success("新增成功");
      } else {
        formData.questionsId = this.questions.questionsId;
        await editInfo(formData);
        Message.success("编辑成功");
      }
      this.dialogVisible = false;
      this.$emit("success");
    }
  }
};
</script>

<style scoped lang="less">
.editor-box {
  display: flex;
  height: 600px;
}
.editor-labels {
  width: 240px;
}
.editor {
  height: 100%;
  width: calc(100% - 240px);
  text-align: center;
  flex: 1;
  img {
    max-height: 600px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Bank/HandsOnBank/HandsOnForm.vue